import { createSlice } from "@reduxjs/toolkit";
const initialState= {
    balance: 0,
  }
const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWalletBalance: (state, action) => {
      state.balance = action.payload;
    },
    addFunds: (state, action) => {
      state.balance += action.payload;
    },
          setDefaultWalletData:(state,action)=>{
return initialState
}
  },
});

export const { setWalletBalance, addFunds,setDefaultWalletData } = walletSlice.actions;
export default walletSlice.reducer;
